/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { FC, useEffect, useState, useRef } from 'react';
import { renderToString } from 'react-dom/server';
import { useTranslation } from 'react-i18next';
import $script from 'scriptjs';
import { Form, useFormApi } from 'informed';
import { useDebounce } from 'usehooks-ts';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import { toast } from 'react-toastify';
import 'dhtmlx-scheduler';
import 'dhtmlx-scheduler/codebase/dhtmlxscheduler_material.css';
import 'dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_year_view';
import 'dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_tooltip';
import '../../../../vendors/dhtmlxScheduler/dhtmlxscheduler_timeline';
import '../../../../vendors/dhtmlxScheduler/dhtmlxscheduler_minical';
import cn from 'classnames';
import { Button } from '@ui-modules';
import { TextField } from '@ui-modules/informed';
import { DRIVE_EDITABLE_STATUS, ERRORS } from '@common/constants';
import { getTripDurationAsText } from '@common/utils';
import { useFacility } from '@common/hooks';
import {
  DriveFormData,
  DrivePatch,
  FacilityDriver,
  FacilityVehicle,
  IChoice,
  IWindowWithScheduler,
  MappedDrive,
  PlannerFormData,
} from '@common/interfaces';
import { ArrowRound, Calendar, Car, Drive, MSN, Pax, PDF, WarningIcon } from '@assets/svg/icons';
import { EditForm, RecurringForceCreate } from './components';
import { Serializer } from '../../utils';
import css from './styles.module.scss';

$script('https://export.dhtmlx.com/scheduler/api.js', 'bundle');

const CAR_CELL_HEIGHT = 130; // px
const TOP_SCALE_HEIGHT = 40; // px
const HEADER_HEIGHT = 60; // px

interface IMobilityPlanner {
  agencyName: string;
  agencyId: number;
  vehicles: FacilityVehicle[];
  drivers: FacilityDriver[];
  drives: MappedDrive[];
  getCurrentDrives: () => void;
  searchField: string;
  city: string;
  locationId: number;
  updateDrive: (data: DrivePatch) => Promise<void>;
  postDriversForm: (data: PlannerFormData) => Promise<void>;
  purposes: IChoice[];
  requestingUnits: IChoice[];
  isAcceptingProcess: boolean;
  currentDate?: string;
  onViewChange: (new_mode: string, new_date: Date) => void;
}

const { scheduler } = window as unknown as IWindowWithScheduler;

interface ISearchField {
  keyword: string;
  setKeyword: (value: string) => void;
}

const SearchField: FC<ISearchField> = ({ keyword, setKeyword }) => {
  const { t } = useTranslation();
  const formApi = useFormApi();

  return (
    <>
      {keyword && (
        <Button
          className={css.reset}
          data-testid="mobility-planner-reset-filter-by-passenger-name"
          text={t('common.btnResetFilters')}
          variant="link"
          onClick={() => {
            formApi.reset();
            setKeyword('');
          }}
        />
      )}
      <TextField
        className={css.field}
        name="search"
        placeholder={t('mobility.filterByPassengerLastName')}
        data-testid="mobility-planner-filter-by-passenger-name"
      />
    </>
  );
};

let savedPlannerData: PlannerFormData;

const MobilityPlanner: FC<IMobilityPlanner> = ({
  agencyName,
  agencyId,
  city,
  drivers,
  drives: rawDrives,
  getCurrentDrives,
  isAcceptingProcess,
  locationId,
  onViewChange,
  postDriversForm,
  purposes,
  requestingUnits,
  searchField,
  currentDate,
  updateDrive,
  vehicles,
}) => {
  const { t } = useTranslation();

  const tempDrives = rawDrives.filter(({ is_hide }) => !is_hide);
  const drives = cloneDeep(tempDrives);

  const [keyword, setKeyword] = useState('');
  const debouncedKeyword = useDebounce(keyword, 1000);

  let schedulerContainer: HTMLElement;
  const formRef = useRef<HTMLDivElement>(null);

  const [formData, setFormData] = useState<MappedDrive | null>(null);

  const [showForceCreateRecurring, setShowForceCreateRecurring] = useState<boolean>(false);
  const [createRecurringErrors, setCreateRecurringErrors] = useState<string[]>([]);

  const {
    facility: { sharedWithAgencies },
  } = useFacility();

  const handleShowCalendar = (): void => {
    if (scheduler.isCalendarVisible()) scheduler.destroyCalendar();
    else
      scheduler.renderCalendar({
        position: 'dhx_minical_icon',
        date: scheduler.getState().date,
        navigation: true,
        handler(date: Date) {
          scheduler.setCurrentView(date);
          scheduler.destroyCalendar();
        },
      });
  };

  const handleExportPDF = (): void => {
    const month_start = moment(scheduler.getState().min_date).format('ll');
    const month_end = moment(scheduler.getState().max_date).format('ll');

    // TO DO: Should be rewrite in JSX
    scheduler.exportToPDF({
      name: `Drive_export_${city}_${agencyName}.pdf`,
      format: 'A2',
      orientation: 'landscape',
      zoom: 0.5,
      header: `
      <style>
        .tiny{font-family:Verdana;font-size:11px;}
        .timeline{width:550px}
        .fLeft{float:left;}
        .fRight{float:right;margin-right:3.3%;}
        .title{font-family:Verdana;font-weight:bold;font-size:12px;color:#0088FF;}
        .dhx_cal_navline,.dhx_timeline_scale_header{display: none !important;}
        .dhx_cal_scale_placeholder,.dhx_cal_header{height: 30px !important; top: 0 !important;}
        .dhx_cal_data{top: 30px !important;}

        .styles_carBlock__i++ng {display:flex;flex-direction:column;position:relative;width:300px;height:150px;}
        .styles_carTop__CiD4K {height:78px}
        .styles_imgWrap__NeuCZ img {max-width: 150px; position:relative;}
        .styles_armoured__oTceC {
          background:  #f9821b;
          border-bottom-left-radius: 30px;
          border-bottom-right-radius: 30px;
          position: absolute;
          z-index: 9;
          left: 3px;
          top: 3px;
          width: 20px;
          height: 20px;
          
        }
        .styles_carLabel__1l1J7 {
          align-item:center!important;
          display:flex;!important
          height:40px!important;
          width:100%;
          line-height: 1!important;
          margin:0!important;
          padding:0!important;
          position:absolute;
          left:0;
          bottom:0;
          z-index: 3;
        }
        .styles_carIcon__qgzEc {
          margin-right: 5px;
          filter: brightness(0.2);
          width: 30px !important;
          height: 30px !important;
        }
        .styles_carIcon__qgzEc img {width:100%;}
        .styles_eventInfo__-XsBP svg {fill:#fff;}
      </style>
      <span class="fLeft title">Passenger Mobility Services</span>
      <span class="fRight title">UN Booking Hub</span><br/>
      <span class="fLeft tiny timeline">Drives for ${city} ${name} from ${month_start} to ${month_end}</span>
    `,
      footer: '',
    });
  };

  useEffect(() => {
    scheduler.skin = 'material';
    scheduler.xy.scale_height = TOP_SCALE_HEIGHT;
    // scheduler.config.dy = 120;
    scheduler.config.details_on_dblclick = true;
    scheduler.config.details_on_create = true;
    scheduler.config.select = false;
    // scheduler.config.first_hour = 6;
    // scheduler.config.last_hour = 21;
    scheduler.config.dblclick_create = !isAcceptingProcess;
    scheduler.config.drag_create = false;
    scheduler.config.drag_move = false;
    scheduler.config.drag_resize = false;
    scheduler.config.readonly = isAcceptingProcess;
    scheduler.config.auto_end_date = true;
    scheduler.config.event_duration = 60;
    scheduler.config.collision_limit = 10; // TO DO: Basically we should do it infinity
    scheduler.config.show_loading = true;

    scheduler.createTimelineView({
      name: 'timeline',
      render: 'bar',
      x_unit: 'minute',
      x_date: '%H:%i',
      x_step: 60,
      x_size: 24,
      y_property: 'vehicle_id',
      section_autoheight: false,
      event_dy: 25,
      event_min_dy: 25,
      dy: CAR_CELL_HEIGHT,
      dx: 280,
      y_unit: vehicles,
    });

    scheduler.templates.timeline_scale_label = (
      _key: any,
      _label: any,
      vehicle: {
        image: any;
        is_disabled: boolean;
        protection: any;
        plate_number: any;
        label: any;
        shared_agency: any;
        shared: any;
        agency_logo: any;
      },
    ) => {
      const {
        image,
        is_disabled,
        protection,
        plate_number,
        label,
        shared_agency,
        shared,
        agency_logo,
      } = vehicle;

      let sharedWith = null;
      if (shared_agency?.length === 1) {
        sharedWith = sharedWithAgencies.find(({ value }) => value === shared_agency[0])?.label;
      } else if (shared_agency?.length > 1) {
        sharedWith = `${shared_agency?.length} ${t('common.agencies')}`;
      }

      return renderToString(
        <div className={cn(css.carBlock, { [css.shared]: shared, [css.disabled]: is_disabled })}>
          <div className={css.carTop}>
            {image ? (
              <div className={css.carImage}>
                <div className={css.imgWrap}>
                  {protection === 'armoured' ? <span className={css.armoured} /> : null}
                  <img src={image} title={label} alt={label} />
                </div>
              </div>
            ) : null}
            {sharedWith && !shared ? (
              <>
                <Car className={css.shared} />
                <span className={css.sharedWith}>{sharedWith}</span>
              </>
            ) : null}
          </div>
          <div className={css.carLabel}>
            {agency_logo ? (
              <div className={css.carIcon}>
                <img src={agency_logo} title="" alt="" />
              </div>
            ) : null}
            <div className={css.carText}>
              <div className={css.carNumber}>{plate_number}</div> {label}
            </div>
          </div>
        </div>,
      );
    };

    scheduler.locale.labels.timeline_tab = 'Timeline';

    scheduler.attachEvent('onTemplatesReady', () => {
      scheduler.templates.event_header = () => '';
      scheduler.templates.event_text = () => '';
      scheduler.templates.event_bar_date = () => '';
      scheduler.templates.event_bar_text = (
        _start: any,
        _end: any,
        event: {
          start_date: any;
          end_date: any;
          is_temporary: any;
          is_conflicting: boolean;
          editable_state: any;
          driver_first_name: any;
          driver_last_name: any;
          passenger_number_of_pax: any;
          passenger_first_name: any;
          passenger_last_name: any;
        },
      ) => {
        const {
          start_date,
          end_date,
          is_temporary,
          editable_state,
          is_conflicting,

          driver_first_name,
          driver_last_name,

          passenger_number_of_pax,
          passenger_first_name,
          passenger_last_name,
        } = event;

        return renderToString(
          <div
            className={cn(css.eventBlock, {
              [css.green]: editable_state === DRIVE_EDITABLE_STATUS.GREEN,
              [css.red]: is_conflicting,
              [css.grey]: editable_state === DRIVE_EDITABLE_STATUS.GREY,
              [css.blue]: editable_state === DRIVE_EDITABLE_STATUS.BLUE,
              [css.temporary]: is_temporary,
            })}
            data-testid={`mobility-planner-event${is_temporary ? '-preview' : ''}`}
          >
            {moment(end_date).diff(start_date, 'hours') < 2 ? (
              <>Info...</>
            ) : (
              <>
                {passenger_number_of_pax ? (
                  <>
                    <span className={css.eventInfo}>
                      <Pax /> {passenger_number_of_pax}
                    </span>
                    <span className={css.eventInfo}>
                      <MSN /> {passenger_first_name} {passenger_last_name}
                    </span>
                  </>
                ) : null}
                <span className={css.eventInfo}>
                  <Drive /> {`${driver_first_name} ${driver_last_name}`}
                </span>
              </>
            )}
          </div>,
        );
      };
    });

    scheduler.attachEvent('onViewChange', onViewChange);

    scheduler.showLightbox = (id: string) => {
      const eventData = scheduler.getEvent(id);
      const { new_event } = scheduler.getState();

      setFormData({
        booking: {
          driver_detail: {},
        },
        ...eventData,
        id: new_event ? undefined : id,
        event_id: id,
      });
    };

    scheduler.init(schedulerContainer, moment(currentDate, 'YYYY-MM-DD').toDate(), 'timeline');
  }, []);

  useEffect(() => {
    scheduler.templates.tooltip_text = (
      _start: Date,
      _end: Date,
      {
        editable_state,
        is_conflicting,
        passenger_email,
        passenger_phone_number,
        passenger_number_of_pax,
        focal_point_first_name,
        focal_point_last_name,

        passenger_agency,
        passenger_first_name,
        passenger_last_name,
        passenger_remarks,

        driver_agency,
        driver_email,
        driver_first_name,
        driver_last_name,
        driver_phone_number,

        ...rest
      }: any,
    ) => {
      const isEditForbidden = editable_state === DRIVE_EDITABLE_STATUS.GREY;

      return renderToString(
        <div className={css.tooltip}>
          <div className={css['tooltip-section']}>
            {is_conflicting ? (
              <div className={css['tooltip-drive-conflicting']}>
                <WarningIcon />
                {t('common.recurring.conflictMessage1')} <br />{' '}
                {t('common.recurring.conflictMessage2')}
              </div>
            ) : null}
            <div className={css['tooltip-drive-schedule']}>
              {t('planner.driveScheduledFor')} <b>{getTripDurationAsText(_start, _end)}</b>
            </div>
            <div className={css['tooltip-info-container']}>
              <div className={css['tooltip-section']}>
                {!driver_agency ? (
                  <div className={css['tooltip-block']}>
                    <p className={css['tooltip-title']}>
                      {t('planner.noDriverInformationAvailable')}
                    </p>
                  </div>
                ) : (
                  <div className={css['tooltip-block']}>
                    <p className={css['tooltip-title']}>{t('common.driver')}</p>
                    <p>
                      <span className={css['tooltip-key']}>{t('common.email')}:</span>
                      {driver_email}
                    </p>
                    <p>
                      <span className={css['tooltip-key']}>{t('common.name')}:</span>
                      {driver_first_name} {driver_last_name}
                    </p>
                    <p>
                      <span className={css['tooltip-key']}>{t('common.phoneNumber')}:</span>
                      {driver_phone_number}
                    </p>
                    <p>
                      <span className={css['tooltip-key']}>{t('common.agency')}:</span>
                      {driver_agency}
                    </p>
                  </div>
                )}
                {!passenger_number_of_pax ? (
                  <div className={css['tooltip-block']}>
                    <p className={css['tooltip-title']}>{t('planner.noPassengers')}</p>
                  </div>
                ) : (
                  <div className={css['tooltip-block']}>
                    <p className={css['tooltip-title']}>{t('common.passenger')}</p>
                    <p>
                      <span className={css['tooltip-key']}>{t('common.name')}:</span>
                      {passenger_first_name} {passenger_last_name}
                    </p>
                    {!isEditForbidden && (
                      <>
                        <p>
                          <span className={css['tooltip-key']}>{t('common.email')}:</span>
                          {passenger_email}
                        </p>

                        <p>
                          <span className={css['tooltip-key']}>{t('common.phoneNumber')}:</span>
                          {passenger_phone_number}
                        </p>
                      </>
                    )}
                    <p>
                      <span className={css['tooltip-key']}>{t('common.agency')}:</span>
                      {passenger_agency}
                    </p>
                    <p>
                      <span className={css['tooltip-key']}>{t('common.remarks')}:</span>
                      {passenger_remarks}
                    </p>
                    <p>
                      <span className={css['tooltip-key']}>{t('planner.numberOfPax')}:</span>
                      {passenger_number_of_pax}
                    </p>
                  </div>
                )}
              </div>
              <div className={css['tooltip-section']}>
                <div className={css['tooltip-block']}>
                  <p className={css['tooltip-title']}>{t('planner.pickUp')}</p>
                  <p>
                    <span className={css['tooltip-key']}>{t('planner.town')}:</span>
                    {rest.pickup_town}
                  </p>
                  <p>
                    <span className={css['tooltip-key']}>{t('mobility.location')}:</span>
                    {rest.pickup_location}
                  </p>
                  <p>
                    <span className={css['tooltip-key']}>{t('common.when')}:</span>
                    {moment(_start).format('DD/MM/YYYY - HH:mm')}
                  </p>
                </div>
                <div className={css['tooltip-block']}>
                  <p className={css['tooltip-title']}>{t('planner.dropOff')}</p>
                  <p>
                    <span className={css['tooltip-key']}>{t('planner.town')}:</span>
                    {rest.dropoff_town}
                  </p>
                  <p>
                    <span className={css['tooltip-key']}>{t('mobility.location')}:</span>
                    {rest.dropoff_location}
                  </p>
                  <p>
                    <span className={css['tooltip-key']}>{t('common.when')}:</span>
                    {moment(_end).format('DD/MM/YYYY - HH:mm')}
                  </p>
                </div>
                {focal_point_first_name && focal_point_last_name && (
                  <div className={css['tooltip-block']}>
                    <p className={css['tooltip-title']}>{t('planner.focalPoint')}</p>
                    <p>{`${focal_point_first_name} ${focal_point_last_name}`}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>,
      );
    };
  }, [drivers]);

  useEffect(() => {
    scheduler.init(schedulerContainer, moment(currentDate, 'YYYY-MM-DD').toDate(), 'timeline');
  }, [currentDate]);

  useEffect(() => {
    scheduler.clearAll();
    scheduler.parse(drives);
  }, [drives]);

  useEffect(() => {
    if (formData && formRef.current) {
      scheduler.startLightbox(formData.event_id, formRef.current);
    }

    return () => {
      scheduler.endLightbox(false, formRef.current);
    };
  }, [formData]);

  useEffect(() => {
    if (searchField) {
      scheduler.filter_timeline = (_id: any, ev: { [x: string]: string }) => {
        const field = ev?.[searchField]?.toUpperCase();
        const key = debouncedKeyword?.toUpperCase() || '';
        if (field && !field?.includes(key)) return false; // will be hidden
        return true; // will be rendered
      };
      scheduler.parse(drives);
    }
  }, [debouncedKeyword]);

  const handleCancel = (): void => {
    if (formRef.current) {
      scheduler.endLightbox(false, formRef.current);
    }
    setFormData(null);
  };

  const handleSave = async (values: DriveFormData): Promise<void> => {
    const { uuid } = values;
    const plannerFormData = Serializer.mapPlannerFormData(values);

    if (formRef.current) {
      scheduler.endLightbox(true, formRef.current);
    }

    if (uuid) {
      const driveData = Serializer.mapPlannerFormDataToUpdateDrive(values, locationId);
      await updateDrive({ ...driveData, uuid });
    } else {
      try {
        await postDriversForm(plannerFormData);

        getCurrentDrives();
        toast.success(t('mobility.messageDrivePublished'));
      } catch (e: any) {
        if (e.message === ERRORS.RECURRING_CONFLICTING) {
          setShowForceCreateRecurring(true);
          setCreateRecurringErrors(e.cause);
          savedPlannerData = plannerFormData;
        }
      }
    }

    setFormData(null);
  };

  return (
    <>
      {formData && (
        <EditForm
          agencyId={agencyId}
          agencyName={agencyName}
          city={city}
          currentDate={currentDate}
          drivers={drivers}
          drives={drives}
          formData={formData}
          formRef={formRef}
          handleCancel={handleCancel}
          handleSave={handleSave}
          locationId={locationId}
          purposes={purposes}
          requestingUnits={requestingUnits}
          vehicles={vehicles}
        />
      )}

      {showForceCreateRecurring ? (
        <RecurringForceCreate
          errors={createRecurringErrors}
          onCancelClick={() => setShowForceCreateRecurring(false)}
          onConfirmClick={async () => {
            setShowForceCreateRecurring(false);
            await postDriversForm({ ...savedPlannerData, force_create: true });

            getCurrentDrives();
            toast.warning(`${t('common.recurring.successMessage')}.\n ${createRecurringErrors}`);
          }}
        />
      ) : null}
      <div
        className={css.wrap}
        style={{
          height: `${5 + HEADER_HEIGHT + TOP_SCALE_HEIGHT + CAR_CELL_HEIGHT * vehicles.length}px`,
        }}
      >
        <div
          className={cn(css.container, 'dhx_cal_container', 'dhx_cal_drives')}
          ref={(input) => {
            if (input) {
              schedulerContainer = input;
            }
          }}
        >
          <div className="dhx_cal_navline">
            <div className={css.flexAligned}>
              <div
                className="dhx_minical_icon"
                id="dhx_minical_icon"
                data-testid="mobility-planner-calendar"
                onClick={handleShowCalendar}
              >
                <Calendar />
              </div>
              <div className="dhx_cal_timenav">
                <div className="dhx_cal_prev_button" data-testid="mobility-planner-previous-day">
                  <ArrowRound style={{ transform: 'rotateZ(90deg)' }} />
                </div>
                <div className="dhx_cal_today_button" data-testid="mobility-planner-today" />
                <div className="dhx_cal_next_button" data-testid="mobility-planner-next-day">
                  <ArrowRound style={{ transform: 'rotateZ(-90deg)' }} />
                </div>
              </div>
            </div>
            <div className="dhx_cal_date" />
            <div className={css.flexAligned}>
              <Form
                className={css.searchForm}
                onChange={(formState) => setKeyword(formState.values.search as string)}
              >
                <SearchField keyword={keyword} setKeyword={setKeyword} />
              </Form>
              <Button
                className={css.exportButton}
                data-testid="mobility-planner-export-current-month-to-pdf"
                icon={<PDF />}
                text={`${t('common.btnExport')} PDF`}
                title={t('planner.titleExport')}
                variant="submit"
                onClick={handleExportPDF}
              />
            </div>
          </div>
          <div className="dhx_cal_header" />
          <div className="dhx_cal_data" />
        </div>
      </div>
    </>
  );
};

export default MobilityPlanner;
